import React from 'react';
import { Link } from 'gatsby-theme-material-ui';

export default function HabrLinkIcon() {
  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.537 46.2268C38.4395 54.3243 30.1628 60.7027 23.3298 64.4704C19.9126 66.3547 16.8629 67.5824 14.3812 68.0487C11.8947 68.5159 10.0111 68.2136 8.88407 67.0865C7.75699 65.9594 7.45463 64.0759 7.92185 61.5894C8.38815 59.1077 9.61585 56.058 11.5001 52.6408C15.2679 45.8078 21.6462 37.5311 29.7437 29.4336C37.8412 21.3361 46.1179 14.9577 52.9509 11.19C56.3681 9.30572 59.4178 8.07802 61.8995 7.61171C64.386 7.14449 66.2696 7.44685 67.3966 8.57393C68.5237 9.70101 68.8261 11.5845 68.3589 14.0711C67.8925 16.5527 66.6648 19.6024 64.7806 23.0197C61.0128 29.8527 54.6345 38.1294 46.537 46.2268Z"
        stroke="url(#paint0_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M59.537 59.2268C51.4395 67.3243 43.1628 73.7027 36.3298 77.4704C32.9126 79.3547 29.8629 80.5824 27.3812 81.0487C24.8947 81.5159 23.0111 81.2136 21.8841 80.0865C20.757 78.9594 20.4546 77.0759 20.9218 74.5894C21.3882 72.1077 22.6159 69.058 24.5001 65.6408C28.2679 58.8078 34.6462 50.5311 42.7437 42.4336C50.8412 34.3361 59.1179 27.9577 65.9509 24.19C69.3681 22.3057 72.4178 21.078 74.8995 20.6117C77.386 20.1445 79.2696 20.4469 80.3966 21.5739C81.5237 22.701 81.8261 24.5845 81.3589 27.0711C80.8925 29.5527 79.6648 32.6024 77.7806 36.0197C74.0128 42.8527 67.6345 51.1294 59.537 59.2268Z"
        stroke="url(#paint1_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M47.537 47.2268C39.4395 55.3243 31.1628 61.7027 24.3298 65.4704C20.9126 67.3547 17.8629 68.5824 15.3812 69.0487C12.8947 69.5159 11.0111 69.2136 9.88407 68.0865C8.75699 66.9594 8.45463 65.0759 8.92185 62.5894C9.38815 60.1077 10.6159 57.058 12.5001 53.6408C16.2679 46.8078 22.6462 38.5311 30.7437 30.4336C38.8412 22.3361 47.1179 15.9577 53.9509 12.19C57.3681 10.3057 60.4178 9.07802 62.8995 8.61171C65.386 8.14449 67.2696 8.44685 68.3966 9.57393C69.5237 10.701 69.8261 12.5845 69.3589 15.0711C68.8925 17.5527 67.6648 20.6024 65.7806 24.0197C62.0128 30.8527 55.6345 39.1294 47.537 47.2268Z"
        stroke="url(#paint2_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M47.537 47.2268C39.4395 55.3243 31.1628 61.7027 24.3298 65.4704C20.9126 67.3547 17.8629 68.5824 15.3812 69.0487C12.8947 69.5159 11.0111 69.2136 9.88407 68.0865C8.75699 66.9594 8.45463 65.0759 8.92185 62.5894C9.38815 60.1077 10.6159 57.058 12.5001 53.6408C16.2679 46.8078 22.6462 38.5311 30.7437 30.4336C38.8412 22.3361 47.1179 15.9577 53.9509 12.19C57.3681 10.3057 60.4178 9.07802 62.8995 8.61171C65.386 8.14449 67.2696 8.44685 68.3966 9.57393C69.5237 10.701 69.8261 12.5845 69.3589 15.0711C68.8925 17.5527 67.6648 20.6024 65.7806 24.0197C62.0128 30.8527 55.6345 39.1294 47.537 47.2268Z"
        stroke="url(#paint3_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M48.537 48.2268C40.4395 56.3243 32.1628 62.7027 25.3298 66.4704C21.9126 68.3547 18.8629 69.5824 16.3812 70.0487C13.8947 70.5159 12.0111 70.2136 10.8841 69.0865C9.75699 67.9594 9.45463 66.0759 9.92185 63.5894C10.3882 61.1077 11.6159 58.058 13.5001 54.6408C17.2679 47.8078 23.6462 39.5311 31.7437 31.4336C39.8412 23.3361 48.1179 16.9577 54.9509 13.19C58.3681 11.3057 61.4178 10.078 63.8995 9.61171C66.386 9.14449 68.2696 9.44685 69.3966 10.5739C70.5237 11.701 70.8261 13.5845 70.3589 16.0711C69.8925 18.5527 68.6648 21.6024 66.7806 25.0197C63.0128 31.8527 56.6345 40.1294 48.537 48.2268Z"
        stroke="url(#paint4_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M49.537 49.2268C41.4395 57.3243 33.1628 63.7027 26.3298 67.4704C22.9126 69.3547 19.8629 70.5824 17.3812 71.0487C14.8947 71.5159 13.0111 71.2136 11.8841 70.0865C10.757 68.9594 10.4546 67.0759 10.9218 64.5894C11.3882 62.1077 12.6159 59.058 14.5001 55.6408C18.2679 48.8078 24.6462 40.5311 32.7437 32.4336C40.8412 24.3361 49.1179 17.9577 55.9509 14.19C59.3681 12.3057 62.4178 11.078 64.8995 10.6117C67.386 10.1445 69.2696 10.4469 70.3966 11.5739C71.5237 12.701 71.8261 14.5845 71.3589 17.0711C70.8925 19.5527 69.6648 22.6024 67.7806 26.0197C64.0128 32.8527 57.6345 41.1294 49.537 49.2268Z"
        stroke="url(#paint5_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M49.537 49.2268C41.4395 57.3243 33.1628 63.7027 26.3298 67.4704C22.9126 69.3547 19.8629 70.5824 17.3812 71.0487C14.8947 71.5159 13.0111 71.2136 11.8841 70.0865C10.757 68.9594 10.4546 67.0759 10.9218 64.5894C11.3882 62.1077 12.6159 59.058 14.5001 55.6408C18.2679 48.8078 24.6462 40.5311 32.7437 32.4336C40.8412 24.3361 49.1179 17.9577 55.9509 14.19C59.3681 12.3057 62.4178 11.078 64.8995 10.6117C67.386 10.1445 69.2696 10.4469 70.3966 11.5739C71.5237 12.701 71.8261 14.5845 71.3589 17.0711C70.8925 19.5527 69.6648 22.6024 67.7806 26.0197C64.0128 32.8527 57.6345 41.1294 49.537 49.2268Z"
        stroke="url(#paint6_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M50.537 50.2268C42.4395 58.3243 34.1628 64.7027 27.3298 68.4704C23.9126 70.3547 20.8629 71.5824 18.3812 72.0487C15.8947 72.5159 14.0111 72.2136 12.8841 71.0865C11.757 69.9594 11.4546 68.0759 11.9218 65.5894C12.3882 63.1077 13.6159 60.058 15.5001 56.6408C19.2679 49.8078 25.6462 41.5311 33.7437 33.4336C41.8412 25.3361 50.1179 18.9577 56.9509 15.19C60.3681 13.3057 63.4178 12.078 65.8995 11.6117C68.386 11.1445 70.2696 11.4469 71.3966 12.5739C72.5237 13.701 72.8261 15.5845 72.3589 18.0711C71.8925 20.5527 70.6648 23.6024 68.7806 27.0197C65.0128 33.8527 58.6345 42.1294 50.537 50.2268Z"
        stroke="url(#paint7_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M50.537 50.2268C42.4395 58.3243 34.1628 64.7027 27.3298 68.4704C23.9126 70.3547 20.8629 71.5824 18.3812 72.0487C15.8947 72.5159 14.0111 72.2136 12.8841 71.0865C11.757 69.9594 11.4546 68.0759 11.9218 65.5894C12.3882 63.1077 13.6159 60.058 15.5001 56.6408C19.2679 49.8078 25.6462 41.5311 33.7437 33.4336C41.8412 25.3361 50.1179 18.9577 56.9509 15.19C60.3681 13.3057 63.4178 12.078 65.8995 11.6117C68.386 11.1445 70.2696 11.4469 71.3966 12.5739C72.5237 13.701 72.8261 15.5845 72.3589 18.0711C71.8925 20.5527 70.6648 23.6024 68.7806 27.0197C65.0128 33.8527 58.6345 42.1294 50.537 50.2268Z"
        stroke="url(#paint8_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M51.537 51.2268C43.4395 59.3243 35.1628 65.7027 28.3298 69.4704C24.9126 71.3547 21.8629 72.5824 19.3812 73.0487C16.8947 73.5159 15.0111 73.2136 13.8841 72.0865C12.757 70.9594 12.4546 69.0759 12.9218 66.5894C13.3882 64.1077 14.6159 61.058 16.5001 57.6408C20.2679 50.8078 26.6462 42.5311 34.7437 34.4336C42.8412 26.3361 51.1179 19.9577 57.9509 16.19C61.3681 14.3057 64.4178 13.078 66.8995 12.6117C69.386 12.1445 71.2696 12.4469 72.3966 13.5739C73.5237 14.701 73.8261 16.5845 73.3589 19.0711C72.8925 21.5527 71.6648 24.6024 69.7806 28.0197C66.0128 34.8527 59.6345 43.1294 51.537 51.2268Z"
        stroke="url(#paint9_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M52.537 52.2268C44.4395 60.3243 36.1628 66.7027 29.3298 70.4704C25.9126 72.3547 22.8629 73.5824 20.3812 74.0487C17.8947 74.5159 16.0111 74.2136 14.8841 73.0865C13.757 71.9594 13.4546 70.0759 13.9218 67.5894C14.3882 65.1077 15.6159 62.058 17.5001 58.6408C21.2679 51.8078 27.6462 43.5311 35.7437 35.4336C43.8412 27.3361 52.1179 20.9577 58.9509 17.19C62.3681 15.3057 65.4178 14.078 67.8995 13.6117C70.386 13.1445 72.2696 13.4469 73.3966 14.5739C74.5237 15.701 74.8261 17.5845 74.3589 20.0711C73.8925 22.5527 72.6648 25.6024 70.7806 29.0197C67.0128 35.8527 60.6345 44.1294 52.537 52.2268Z"
        stroke="url(#paint10_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M52.537 52.2268C44.4395 60.3243 36.1628 66.7027 29.3298 70.4704C25.9126 72.3547 22.8629 73.5824 20.3812 74.0487C17.8947 74.5159 16.0111 74.2136 14.8841 73.0865C13.757 71.9594 13.4546 70.0759 13.9218 67.5894C14.3882 65.1077 15.6159 62.058 17.5001 58.6408C21.2679 51.8078 27.6462 43.5311 35.7437 35.4336C43.8412 27.3361 52.1179 20.9577 58.9509 17.19C62.3681 15.3057 65.4178 14.078 67.8995 13.6117C70.386 13.1445 72.2696 13.4469 73.3966 14.5739C74.5237 15.701 74.8261 17.5845 74.3589 20.0711C73.8925 22.5527 72.6648 25.6024 70.7806 29.0197C67.0128 35.8527 60.6345 44.1294 52.537 52.2268Z"
        stroke="url(#paint11_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M53.537 53.2268C45.4395 61.3243 37.1628 67.7027 30.3298 71.4704C26.9126 73.3547 23.8629 74.5824 21.3812 75.0487C18.8947 75.5159 17.0111 75.2136 15.8841 74.0865C14.757 72.9594 14.4546 71.0759 14.9218 68.5894C15.3882 66.1077 16.6159 63.058 18.5001 59.6408C22.2679 52.8078 28.6462 44.5311 36.7437 36.4336C44.8412 28.3361 53.1179 21.9577 59.9509 18.19C63.3681 16.3057 66.4178 15.078 68.8995 14.6117C71.386 14.1445 73.2696 14.4469 74.3966 15.5739C75.5237 16.701 75.8261 18.5845 75.3589 21.0711C74.8925 23.5527 73.6648 26.6024 71.7806 30.0197C68.0128 36.8527 61.6345 45.1294 53.537 53.2268Z"
        stroke="url(#paint12_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M54.537 54.2268C46.4395 62.3243 38.1628 68.7027 31.3298 72.4704C27.9126 74.3547 24.8629 75.5824 22.3812 76.0487C19.8947 76.5159 18.0111 76.2136 16.8841 75.0865C15.757 73.9594 15.4546 72.0759 15.9218 69.5894C16.3882 67.1077 17.6159 64.058 19.5001 60.6408C23.2679 53.8078 29.6462 45.5311 37.7437 37.4336C45.8412 29.3361 54.1179 22.9577 60.9509 19.19C64.3681 17.3057 67.4178 16.078 69.8995 15.6117C72.386 15.1445 74.2696 15.4469 75.3966 16.5739C76.5237 17.701 76.8261 19.5845 76.3589 22.0711C75.8925 24.5527 74.6648 27.6024 72.7806 31.0197C69.0128 37.8527 62.6345 46.1294 54.537 54.2268Z"
        stroke="url(#paint13_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M54.537 54.2268C46.4395 62.3243 38.1628 68.7027 31.3298 72.4704C27.9126 74.3547 24.8629 75.5824 22.3812 76.0487C19.8947 76.5159 18.0111 76.2136 16.8841 75.0865C15.757 73.9594 15.4546 72.0759 15.9218 69.5894C16.3882 67.1077 17.6159 64.058 19.5001 60.6408C23.2679 53.8078 29.6462 45.5311 37.7437 37.4336C45.8412 29.3361 54.1179 22.9577 60.9509 19.19C64.3681 17.3057 67.4178 16.078 69.8995 15.6117C72.386 15.1445 74.2696 15.4469 75.3966 16.5739C76.5237 17.701 76.8261 19.5845 76.3589 22.0711C75.8925 24.5527 74.6648 27.6024 72.7806 31.0197C69.0128 37.8527 62.6345 46.1294 54.537 54.2268Z"
        stroke="url(#paint14_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M55.537 55.2268C47.4395 63.3243 39.1628 69.7027 32.3298 73.4704C28.9126 75.3547 25.8629 76.5824 23.3812 77.0487C20.8947 77.5159 19.0111 77.2136 17.8841 76.0865C16.757 74.9594 16.4546 73.0759 16.9218 70.5894C17.3882 68.1077 18.6159 65.058 20.5001 61.6408C24.2679 54.8078 30.6462 46.5311 38.7437 38.4336C46.8412 30.3361 55.1179 23.9577 61.9509 20.19C65.3681 18.3057 68.4178 17.078 70.8995 16.6117C73.386 16.1445 75.2696 16.4469 76.3966 17.5739C77.5237 18.701 77.8261 20.5845 77.3589 23.0711C76.8925 25.5527 75.6648 28.6024 73.7806 32.0197C70.0128 38.8527 63.6345 47.1294 55.537 55.2268Z"
        stroke="url(#paint15_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M56.537 56.2268C48.4395 64.3243 40.1628 70.7027 33.3298 74.4704C29.9126 76.3547 26.8629 77.5824 24.3812 78.0487C21.8947 78.5159 20.0111 78.2136 18.8841 77.0865C17.757 75.9594 17.4546 74.0759 17.9218 71.5894C18.3882 69.1077 19.6159 66.058 21.5001 62.6408C25.2679 55.8078 31.6462 47.5311 39.7437 39.4336C47.8412 31.3361 56.1179 24.9577 62.9509 21.19C66.3681 19.3057 69.4178 18.078 71.8995 17.6117C74.386 17.1445 76.2696 17.4469 77.3966 18.5739C78.5237 19.701 78.8261 21.5845 78.3589 24.0711C77.8925 26.5527 76.6648 29.6024 74.7806 33.0197C71.0128 39.8527 64.6345 48.1294 56.537 56.2268Z"
        stroke="url(#paint16_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M56.537 56.2268C48.4395 64.3243 40.1628 70.7027 33.3298 74.4704C29.9126 76.3547 26.8629 77.5824 24.3812 78.0487C21.8947 78.5159 20.0111 78.2136 18.8841 77.0865C17.757 75.9594 17.4546 74.0759 17.9218 71.5894C18.3882 69.1077 19.6159 66.058 21.5001 62.6408C25.2679 55.8078 31.6462 47.5311 39.7437 39.4336C47.8412 31.3361 56.1179 24.9577 62.9509 21.19C66.3681 19.3057 69.4178 18.078 71.8995 17.6117C74.386 17.1445 76.2696 17.4469 77.3966 18.5739C78.5237 19.701 78.8261 21.5845 78.3589 24.0711C77.8925 26.5527 76.6648 29.6024 74.7806 33.0197C71.0128 39.8527 64.6345 48.1294 56.537 56.2268Z"
        stroke="url(#paint17_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M57.537 57.2268C49.4395 65.3243 41.1628 71.7027 34.3298 75.4704C30.9126 77.3547 27.8629 78.5824 25.3812 79.0487C22.8947 79.5159 21.0111 79.2136 19.8841 78.0865C18.757 76.9594 18.4546 75.0759 18.9218 72.5894C19.3882 70.1077 20.6159 67.058 22.5001 63.6408C26.2679 56.8078 32.6462 48.5311 40.7437 40.4336C48.8412 32.3361 57.1179 25.9577 63.9509 22.19C67.3681 20.3057 70.4178 19.078 72.8995 18.6117C75.386 18.1445 77.2696 18.4469 78.3966 19.5739C79.5237 20.701 79.8261 22.5845 79.3589 25.0711C78.8925 27.5527 77.6648 30.6024 75.7806 34.0197C72.0128 40.8527 65.6345 49.1294 57.537 57.2268Z"
        stroke="url(#paint18_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M57.537 57.2268C49.4395 65.3243 41.1628 71.7027 34.3298 75.4704C30.9126 77.3547 27.8629 78.5824 25.3812 79.0487C22.8947 79.5159 21.0111 79.2136 19.8841 78.0865C18.757 76.9594 18.4546 75.0759 18.9218 72.5894C19.3882 70.1077 20.6159 67.058 22.5001 63.6408C26.2679 56.8078 32.6462 48.5311 40.7437 40.4336C48.8412 32.3361 57.1179 25.9577 63.9509 22.19C67.3681 20.3057 70.4178 19.078 72.8995 18.6117C75.386 18.1445 77.2696 18.4469 78.3966 19.5739C79.5237 20.701 79.8261 22.5845 79.3589 25.0711C78.8925 27.5527 77.6648 30.6024 75.7806 34.0197C72.0128 40.8527 65.6345 49.1294 57.537 57.2268Z"
        stroke="url(#paint19_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M58.537 58.2268C50.4395 66.3243 42.1628 72.7027 35.3298 76.4704C31.9126 78.3547 28.8629 79.5824 26.3812 80.0487C23.8947 80.5159 22.0111 80.2136 20.8841 79.0865C19.757 77.9594 19.4546 76.0759 19.9218 73.5894C20.3882 71.1077 21.6159 68.058 23.5001 64.6408C27.2679 57.8078 33.6462 49.5311 41.7437 41.4336C49.8412 33.3361 58.1179 26.9577 64.9509 23.19C68.3681 21.3057 71.4178 20.078 73.8995 19.6117C76.386 19.1445 78.2696 19.4469 79.3966 20.5739C80.5237 21.701 80.8261 23.5845 80.3589 26.0711C79.8925 28.5527 78.6648 31.6024 76.7806 35.0197C73.0128 41.8527 66.6345 50.1294 58.537 58.2268Z"
        stroke="url(#paint20_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M59.537 59.2268C51.4395 67.3243 43.1628 73.7027 36.3298 77.4704C32.9126 79.3547 29.8629 80.5824 27.3812 81.0487C24.8947 81.5159 23.0111 81.2136 21.8841 80.0865C20.757 78.9594 20.4546 77.0759 20.9218 74.5894C21.3882 72.1077 22.6159 69.058 24.5001 65.6408C28.2679 58.8078 34.6462 50.5311 42.7437 42.4336C50.8412 34.3361 59.1179 27.9577 65.9509 24.19C69.3681 22.3057 72.4178 21.078 74.8995 20.6117C77.386 20.1445 79.2696 20.4469 80.3966 21.5739C81.5237 22.701 81.8261 24.5845 81.3589 27.0711C80.8925 29.5527 79.6648 32.6024 77.7806 36.0197C74.0128 42.8527 67.6345 51.1294 59.537 59.2268Z"
        stroke="url(#paint21_linear_9077_121339)"
        strokeWidth="0.250743"
      />
      <path
        d="M30.5756 29.8341H27.2436V39.8301H25.2376V29.8341H21.9056V27.9301H30.5756V29.8341ZM35.244 27.7601C36.06 27.7601 36.8023 27.9811 37.471 28.4231C38.1397 28.8651 38.6723 29.5451 39.069 30.4631C39.4657 31.3811 39.664 32.5201 39.664 33.8801C39.664 35.2401 39.4657 36.3791 39.069 37.2971C38.6723 38.2151 38.1397 38.8951 37.471 39.3371C36.8023 39.7791 36.06 40.0001 35.244 40.0001C34.428 40.0001 33.6857 39.7791 33.017 39.3371C32.3483 38.8951 31.8157 38.2151 31.419 37.2971C31.0223 36.3791 30.824 35.2401 30.824 33.8801C30.824 32.5201 31.0223 31.3811 31.419 30.4631C31.8157 29.5451 32.3483 28.8651 33.017 28.4231C33.6857 27.9811 34.428 27.7601 35.244 27.7601ZM35.244 38.0961C35.6973 38.0961 36.1053 37.9431 36.468 37.6371C36.8307 37.3197 37.1197 36.8437 37.335 36.2091C37.5503 35.5744 37.658 34.7981 37.658 33.8801C37.658 32.9621 37.5447 32.1857 37.318 31.5511C37.1027 30.9164 36.808 30.4461 36.434 30.1401C36.0713 29.8227 35.6747 29.6641 35.244 29.6641C34.7907 29.6641 34.3827 29.8227 34.02 30.1401C33.6573 30.4461 33.3683 30.9164 33.153 31.5511C32.9377 32.1857 32.83 32.9621 32.83 33.8801C32.83 34.7981 32.9377 35.5744 33.153 36.2091C33.3797 36.8437 33.6743 37.3197 34.037 37.6371C34.411 37.9431 34.8133 38.0961 35.244 38.0961ZM48.0213 39.8301H46.0153V29.8341H42.4793V39.8301H40.4733V27.9301H48.0213V39.8301ZM55.9537 33.8971V35.8011H50.5477V33.8971H55.9537ZM65.0251 33.3021C65.6824 33.9254 66.0111 34.8264 66.0111 36.0051C66.0111 36.8437 65.8354 37.5634 65.4841 38.1641C65.1327 38.7647 64.6454 39.2237 64.0221 39.5411C63.4101 39.8471 62.7187 40.0001 61.9481 40.0001C61.0527 40.0001 60.2764 39.8187 59.6191 39.4561C58.9731 39.0934 58.4234 38.5381 57.9701 37.7901L59.4321 36.5661C59.9987 37.5861 60.8374 38.0961 61.9481 38.0961C62.5827 38.0961 63.0814 37.9147 63.4441 37.5521C63.8181 37.1894 64.0051 36.7134 64.0051 36.1241C64.0051 35.4894 63.8294 35.0134 63.4781 34.6961C63.1381 34.3674 62.6677 34.2031 62.0671 34.2031C61.4211 34.2031 60.7977 34.2937 60.1971 34.4751L59.8911 33.4381L62.6961 29.8341H58.5311V27.9301H65.4841V29.0861L62.9171 32.3841C63.3251 32.4294 63.7161 32.5314 64.0901 32.6901C64.4641 32.8487 64.7757 33.0527 65.0251 33.3021Z"
        fill="white"
      />
      <path
        d="M32.675 57.8301L30.21 53.5631L27.728 57.8301H25.433L29.02 51.8291L25.501 45.9301H27.881L30.261 50.0611L32.675 45.9301H34.97L31.451 51.7951L35.055 57.8301H32.675ZM40.9303 54.9231H37.5643L36.9013 57.8301H34.8613L37.6833 45.9301H40.8113L43.6333 57.8301H41.5933L40.9303 54.9231ZM40.4883 53.0191L39.2303 47.5621L37.9893 53.0191H40.4883ZM48.7437 50.5201C49.469 50.5201 50.1094 50.6674 50.6647 50.9621C51.22 51.2567 51.6507 51.6817 51.9567 52.2371C52.2627 52.7924 52.4157 53.4384 52.4157 54.1751C52.4157 54.9117 52.2627 55.5577 51.9567 56.1131C51.6507 56.6684 51.22 57.0934 50.6647 57.3881C50.1094 57.6827 49.469 57.8301 48.7437 57.8301H44.6297V45.9301H51.5147V47.8341H46.6357V50.5201H48.7437ZM48.5567 55.9261C49.18 55.9261 49.6447 55.7731 49.9507 55.4671C50.2567 55.1611 50.4097 54.7304 50.4097 54.1751C50.4097 53.6197 50.2567 53.1891 49.9507 52.8831C49.6447 52.5771 49.18 52.4241 48.5567 52.4241H46.6357V55.9261H48.5567ZM57.7811 45.9301C58.9371 45.9301 59.8551 46.2757 60.5351 46.9671C61.2151 47.6471 61.5551 48.5707 61.5551 49.7381C61.5551 50.9054 61.2151 51.8347 60.5351 52.5261C59.8551 53.2061 58.9371 53.5461 57.7811 53.5461H55.5031V57.8301H53.4971V45.9301H57.7811ZM57.4921 51.6421C58.1947 51.6421 58.7104 51.4777 59.0391 51.1491C59.3791 50.8091 59.5491 50.3387 59.5491 49.7381C59.5491 49.1374 59.3791 48.6727 59.0391 48.3441C58.7104 48.0041 58.1947 47.8341 57.4921 47.8341H55.5031V51.6421H57.4921Z"
        fill="white"
      />
      <Link href="https://habr.com/ru/articles/710330/" target="_blank">
        <path
          cursor={'pointer'}
          d="M69.7594 48.3271C68.8868 48.5764 68.0084 48.8767 67.1244 49.2281C68.0424 49.6134 68.9208 49.9251 69.7594 50.1631L68.8074 51.8121C68.1501 51.1661 67.4418 50.5541 66.6824 49.9761C66.7844 50.7921 66.9601 51.7101 67.2094 52.7301H65.3054C65.5208 51.8347 65.6908 50.9224 65.8154 49.9931C65.1468 50.5031 64.4441 51.1094 63.7074 51.8121L62.7554 50.1631C63.5941 49.9251 64.4724 49.6134 65.3904 49.2281C64.5064 48.8767 63.6281 48.5764 62.7554 48.3271L63.7074 46.6781C64.3761 47.3127 65.0788 47.9134 65.8154 48.4801C65.6908 47.5507 65.5208 46.6441 65.3054 45.7601H67.2094C66.9714 46.7574 66.7958 47.6697 66.6824 48.4971C67.4078 47.9417 68.1161 47.3354 68.8074 46.6781L69.7594 48.3271Z"
          fill="#FFBC5B"
        />
      </Link>
      <defs>
        <linearGradient
          id="paint0_linear_9077_121339"
          x1="67.4853"
          y1="8.48528"
          x2="8.79542"
          y2="67.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9077_121339"
          x1="80.4853"
          y1="21.4853"
          x2="21.7954"
          y2="80.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9077_121339"
          x1="68.4853"
          y1="9.48528"
          x2="9.79542"
          y2="68.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_9077_121339"
          x1="68.4853"
          y1="9.48528"
          x2="9.79542"
          y2="68.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_9077_121339"
          x1="69.4853"
          y1="10.4853"
          x2="10.7954"
          y2="69.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_9077_121339"
          x1="70.4853"
          y1="11.4853"
          x2="11.7954"
          y2="70.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_9077_121339"
          x1="70.4853"
          y1="11.4853"
          x2="11.7954"
          y2="70.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_9077_121339"
          x1="71.4853"
          y1="12.4853"
          x2="12.7954"
          y2="71.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_9077_121339"
          x1="71.4853"
          y1="12.4853"
          x2="12.7954"
          y2="71.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_9077_121339"
          x1="72.4853"
          y1="13.4853"
          x2="13.7954"
          y2="72.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_9077_121339"
          x1="73.4853"
          y1="14.4853"
          x2="14.7954"
          y2="73.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_9077_121339"
          x1="73.4853"
          y1="14.4853"
          x2="14.7954"
          y2="73.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_9077_121339"
          x1="74.4853"
          y1="15.4853"
          x2="15.7954"
          y2="74.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_9077_121339"
          x1="75.4853"
          y1="16.4853"
          x2="16.7954"
          y2="75.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_9077_121339"
          x1="75.4853"
          y1="16.4853"
          x2="16.7954"
          y2="75.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_9077_121339"
          x1="76.4853"
          y1="17.4853"
          x2="17.7954"
          y2="76.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_9077_121339"
          x1="77.4853"
          y1="18.4853"
          x2="18.7954"
          y2="77.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_9077_121339"
          x1="77.4853"
          y1="18.4853"
          x2="18.7954"
          y2="77.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_9077_121339"
          x1="78.4853"
          y1="19.4853"
          x2="19.7954"
          y2="78.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_9077_121339"
          x1="78.4853"
          y1="19.4853"
          x2="19.7954"
          y2="78.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_9077_121339"
          x1="79.4853"
          y1="20.4853"
          x2="20.7954"
          y2="79.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_9077_121339"
          x1="80.4853"
          y1="21.4853"
          x2="21.7954"
          y2="80.1751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBBA5A" />
          <stop offset="1" stopColor="#671FFF" stopOpacity="0.93" />
        </linearGradient>
      </defs>
    </svg>
  );
}
